function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-37a7df50\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./volume10.vue")
}
var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"babelrc\":false,\"presets\":[[\"@babel/preset-env\",{\"targets\":[\"> 1%\",\"iOS >= 8.0\",\"Android >= 4.4\",\"Chrome >= 30\",\"Safari >= 9\",\"Firefox ESR\",\"Opera 12.1\"]}]]}!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./volume10.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-37a7df50\",\"hasScoped\":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./volume10.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37a7df50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/map/decoration/visualization/eco2/volume10.vue
// module id = 743
// module chunks = 0